import { AnimatePresence } from "framer-motion";
import { useMemo, useState } from "react";
import { categories, fears } from "../data/fears";
import FearCard from "./FearCard";

function FearGallery() {
  const [activeCategory, setActiveCategory] = useState("All");
  const filteredFears = useMemo(
    () => activeCategory === "All" ? fears : fears.filter((fear) => fear.category === activeCategory),
    [activeCategory]
  );

  return (
    <section id="gallery" className="mx-auto w-full max-w-7xl scroll-mt-24 px-5 py-20 lg:px-8">
      <div className="mb-9 flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <p className="text-xs uppercase tracking-[0.32em] text-museum-gold">Gallery Hall</p>
          <h2 className="mt-4 font-display text-4xl text-museum-bone sm:text-5xl">Exhibits</h2>
        </div>
        <div className="flex flex-wrap gap-2" aria-label="Fear categories">
          {categories.map((category) => (
            <button
              key={category}
              type="button"
              onClick={() => setActiveCategory(category)}
              className={`rounded-full border px-4 py-2 text-xs uppercase tracking-[0.18em] transition ${
                activeCategory === category
                  ? "border-museum-gold bg-museum-gold/12 text-museum-bone"
                  : "border-museum-bone/12 text-museum-muted hover:border-museum-gold/60 hover:text-museum-bone"
              }`}
            >
              {category}
            </button>
          ))}
        </div>
      </div>
      <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-4">
        <AnimatePresence mode="popLayout">
          {filteredFears.map((fear) => (
            <FearCard key={fear.slug} fear={fear} />
          ))}
        </AnimatePresence>
      </div>
    </section>
  );
}

export default FearGallery;
